const ERROR_PAGES_BASE_URL = 'https://error-sites.platego.io'

export type ErrorTemplate = '404' | '503' | '5xx'

export function getErrorTemplate(statusCode: number): ErrorTemplate | null {
    if (statusCode === 404) return '404'
    if (statusCode === 503) return '503'
    if (statusCode >= 500 && statusCode < 600) return '5xx'
    return null
}

export function getErrorPageUrl(brand: string, jurisdiction: string, errorTemplate: ErrorTemplate, errorMessage?: string): string {
    const url = new URL(`${ERROR_PAGES_BASE_URL}/${brand}_${jurisdiction.toLowerCase()}_${errorTemplate}.html`)
    if (errorMessage) {
        url.searchParams.set('error', errorMessage)
    }
    return url.toString()
}
